export default __webpack_public_path__ + "static/media/035-swordfish.e3821c43.svg";